import styled from 'styled-components'

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 24px;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  line-height: 20px;
`

export const Person = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding-top: 16px;
`

export const AvatarWrap = styled.div`
  flex-shrink: 0;
  width: 40px;
  height: 40px;

  div,
  img {
    width: 40px;
    height: 40px;
    margin: 0;
  }
`

export const PersonInfo = styled.div`
  min-width: 0;
`

export const PersonName = styled.p`
  && {
    margin: 0;
    color: #002a6d;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
  }
`

export const PersonMeta = styled.p`
  && {
    margin: 0;
    color: #757575;
    font-size: 14px;
    line-height: 20px;
  }
`

export const Sections = styled.div`
  display: flex;
  flex-direction: column;
`

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px 0;

  &:first-child {
    padding-top: 20px;
  }

  &:last-child {
    padding-bottom: 0;
  }

  & + & {
    border-top: 1px solid #d9d9d9;
  }
`

export const SectionTitle = styled.p`
  && {
    margin: 0;
    color: #002a6d;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
  }
`

export const InlineValue = styled.p`
  && {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
    font-size: 14px;
    line-height: 20px;
  }

  svg {
    color: currentColor;
    font-size: 14px;
  }
`

export const ValueTag = styled.span`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 4px;
  padding: 2px 4px;
  font-family: Roboto, sans-serif;
  border: 1px solid #bfbfbf;
  border-radius: 8px;
  background: #ffffff;
  color: #363636;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  svg {
    font-size: 14px;
    color: #363636;
  }
`

export const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  span {
    padding-top: 2px;
    padding-bottom: 2px;
    font-family: Roboto, sans-serif;
  }
`

export const NameList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    font-size: 14px;
    line-height: 20px;
  }
`

export const ScrollList = styled(NameList)`
  max-height: calc(5 * 20px + 4 * 8px);
  overflow-y: auto;
  border: none;
`

export const Empty = styled.p`
  && {
    margin: 0;
    color: #757575;
    font-size: 14px;
    line-height: 20px;
  }
`
